/* eslint-disable */
export default {
  topic: 'Tapaamisen otsikko',
} as const;

// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
